<template>
    <v-layout row>
        <v-flex xs12>
            <v-form v-model="valid">
                <v-card>
                    <v-card-text>

                        <v-layout row>
                            <v-flex xs8>
                                <v-switch label="Kombinationen" v-model="active" :disabled="disabled || event.starter_type_combinations.length > 0"></v-switch>
                            </v-flex>
                            <v-flex xs4>
                                <v-tooltip bottom>
                                    <v-btn class="right" :disabled="disabled" slot="activator" @click="add"><v-icon>add</v-icon></v-btn>
                                    <span v-t="'add_combination'"></span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-btn class="right" :disabled="disabled" slot="activator" @click="remove" v-show="event.starter_type_combinations.length > 0"><v-icon>remove</v-icon></v-btn>
                                    <span v-t="'remove_combination'"></span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>


                        <v-layout row v-for="(combination, index) in event.starter_type_combinations" :key="combination.id">
                            <v-flex xs5>
                                <v-text-field :label="$t('name')"
                                              v-model="combination.name"
                                              required
                                              :rules="rules.name"
                                              :disabled="disabled"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs7>
                                <v-select :label="$t('combinations')"
                                          :items="availableStarterTypes(index)"
                                          item-value="id"
                                          item-text="name"
                                          return-object
                                          multiple
                                          v-model="combination.starter_types"
                                          required
                                          :rules="rules.combinations"
                                          :disabled="disabled"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            value: {
                type: Array
            },
            event: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                active: false,
                combinations: [],
                $validates: true,
                valid: false,
                rules: {
                    name: [
                        (v) => !!v || 'Name fehlt'
                    ],
                    combinations: [
                        (v) => !!v || 'Starterklassen fehlen',
                        (v) => _.every(this.combinations, c => c.starter_types.length > 0) || 'Starterklassen fehlen'
                    ]
                }
            }
        },
        watch: {
            active(val) {
                if (val && this.event.starter_type_combinations.length === 0) {
                    this.add();
                }
            },
            valid(val) {
                this.$emit('validationUpdated', val);
            },
            event: {
                handler(val) {
                    if (this.event.starter_type_combinations.length > 0 !== this.active) {
                        this.active = this.event.starter_type_combinations.length > 0;
                    }
                },
                deep: true
            }
        },
        computed: {
            ...mapState(['starterTypes'])
        },
        mounted() {
            this.active = this.event.starter_type_combinations.length > 0;
        },
        methods: {
            add() {
                this.event.starter_type_combinations.push({
                    id: null,
                    event_id: this.event.id,
                    name: '',
                    starter_types: []
                });
            },
            remove() {
                if (this.event.starter_type_combinationslength === 0) {
                    return;
                }

                let index = this.event.starter_type_combinations.length - 1;

                this.event.starter_type_combinations.splice(index, 1);
            },
            availableStarterTypes(index) {
                let excludedItems = [];
                _.each(this.event.starter_type_combinations, (c, i) => {
                    if (parseInt(i) === index) {
                        return true;
                    }

                    _.each(c.starter_types, st => {
                        excludedItems.push(st);
                    });
                });

                return _.filter(this.starterTypes.items,
                    s =>
                    s.event_rule_id === this.event.event_rule_id &&
                    _.every(excludedItems, st => st.id !== s.id)
                );
            }
        }
    }
</script>

<style scoped>
    .right {
        float: right;
    }
</style>
